// @flow
import React, { Component } from 'react';

import ContentBox from '../ContentBox.jsx';
import PageHeader from '../PageHeader.jsx';
import DrugTable from './DrugTable.jsx';

type Props = {
  match: Object,
}

class PharmacyInventoryPage extends Component<Props> {
  render() {
    const { match } = this.props;

    return (
      <div>
        <PageHeader title='Inventory' />
        <ContentBox id='allergymedicine' title='Allergy Medicine'>
          <DrugTable category='Allergy Medicine' match={match} />
        </ContentBox>
        <ContentBox id='antibiotics' title='Antibiotics'>
          <DrugTable category='Antibiotics' match={match} />
        </ContentBox>
        <ContentBox id='antiepileptics' title='Anti-epileptics'>
          <DrugTable category='Anti-epileptics' match={match} />
        </ContentBox>
        <ContentBox id='antifungals' title='Antifungals'>
          <DrugTable category='Antifungals' match={match} />
        </ContentBox>
        <ContentBox id='antivirals' title='Antivirals'>
          <DrugTable category='Antivirals' match={match} />
        </ContentBox>
        <ContentBox id='respiratory' title='Respiratory Meds'>
          <DrugTable category='Respiratory Meds' match={match} />
        </ContentBox>
        <ContentBox id='decongestants' title='Decongestants'>
          <DrugTable category='Decongestants' match={match} />
        </ContentBox>
        <ContentBox id='steroids' title='Steroids'>
          <DrugTable category='Steroids' match={match} />
        </ContentBox>
        <ContentBox id='supplements' title='Supplements'>
          <DrugTable category='Supplements' match={match} />
        </ContentBox>
        <ContentBox id='immunizations' title='Immunizations'>
          <DrugTable category='Immunizations' match={match} />
        </ContentBox>
        <ContentBox id='analgesics' title='Analgesics'>
          <DrugTable category='Analgesics' match={match} />
        </ContentBox>
        <ContentBox id='adhd' title='ADHD Meds'>
          <DrugTable category='ADHD Meds' match={match} />
        </ContentBox>
        <ContentBox id='gi' title='GI Meds'>
          <DrugTable category='GI Meds' match={match} />
        </ContentBox>
        <ContentBox id='muscleRelaxants' title='Muscle Relaxants'>
          <DrugTable category='Muscle Relaxants' match={match} />
        </ContentBox>
        <ContentBox id='other' title='Other'>
          <DrugTable category='Other' match={match} />
        </ContentBox>
      </div>
    );
  }
}

export default PharmacyInventoryPage;



// WEBPACK FOOTER //
// ./client/src/components/pharmacyPages/PharmacyInventoryPage.jsx